import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubjects } from '../../hooks/useSubjects';
import SubjectForm from '../../components/forms/SubjectForm';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const SubjectNew = () => {
  const navigate = useNavigate();
  const { addSubject } = useSubjects();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (formData) => {
    setLoading(true);
    try {
      const result = await addSubject(formData);
      if (result.success) {
        alert('Subject created successfully!');
        navigate('/subjects');
      } else {
        alert(result.error || 'Failed to create subject');
      }
    } catch (error) {
      alert('An unexpected error occurred');
      console.error('Error creating subject:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/subjects');
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center space-x-4">
        <Button 
          variant="outline" 
          onClick={handleCancel}
          className="flex items-center"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-1" />
          Back
        </Button>
        <h1 className="text-xl font-bold text-gray-900">Add New Subject</h1>
      </div>
      
      <Card>
        <SubjectForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default SubjectNew;